import { useEffect } from 'react';

/**
 * Hook to add and remove an event listener from an OpenLayers object.
 * @param {Object} obj - The OpenLayers object to add the event listener to.
 * @param {string} event - The event to listen for.
 * @param {Function} callback - The callback function to execute when the event is triggered.
 */
export default function useOlEvent(obj, event, callback) {
  useEffect(() => {
    // If the OpenLayers object exists, add the event listener
    if (obj) {
      obj.on(event, callback);
    }

    // Return a cleanup function that removes the event listener
    return () => {
      if (obj) {
        obj.un(event, callback);
      }
    };
  }, [obj, event, callback]); // Only re-call effect if obj, event or callback changes
}
